import { css } from 'styled-components'

export const mobileMenuLinkStyles = css`
  display: block;
  text-align: left;
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  letter-spacing: 0.1em;
  font-weight: 500;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.grayscale.white};
  text-decoration: none;
  text-transform: uppercase;
  &:hover {
    text-decoration: none;
  }
  &:focus {
    outline: none !important;
  }

  @media (min-width: 768px) {
    font-size: 1rem;
    font-weight: 500;
  }
`

export const mobileMenuButtonStyles = css`
  // override user-agent styles
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
`

export const mobileMenuButtonLinkStyles = css`
  ${mobileMenuLinkStyles};
  ${mobileMenuButtonStyles};
`
